import React from 'react';
import UploadView from './UploadViewContainer';
import { getFileTypes } from 'src/helpers/upload';
import UploadPad from 'src/ui/library/ContentParser/controls/FileUploadControl/UploadPad.js';
import { ATTACHMENT_TYPES } from 'src/constants/constants';
import { addCMSFile, removeCMSFile, downloadCMSFile } from 'src/services/cms.service';
import download from 'downloadjs';
import mime from 'mime-types';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';

const getAnswerId = attachment => (typeof attachment.answerId === 'number' ? attachment.answerId : attachment.id);

class FileUploadControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: this.getInitialAttachments(),
      selectedAttachments: [],
    };
  }

  getInitialAttachments = () => {
    const { uploadedDocuments } = this.props;

    if (!uploadedDocuments) return [];

    //this is only used when the control is being populated with metadata instead of actual Files
    const attachments = uploadedDocuments.map(({ answerId, documentName, fileLength }) => {
      this.props.onChange({ target: { value: documentName } });

      return {
        answerId,
        fileName: documentName,
        fileSize: fileLength,
      };
    });

    return attachments;
  };

  handleOnChange = () => {
    const { onChange } = this.props;
    const { attachments } = this.state;

    // const attachmentData = attachments.map(item => ({
    //   id: item.id,
    //   fileName: item.fileName
    // }));

    if (attachments.length && attachments[0].fileName) onChange({ target: { value: attachments[0].fileName } });
  };

  handleOnDrop = fileData => {
    this.sendFile(fileData);
  };

  sendFile = fileData => {
    const { id, pageId } = this.props;

    fileData.forEach((attachment, index) => {
      const data = new FormData();

      data.append('attachmentData', fileData[index]);
      data.append('elementName', id);
      data.append('pageId', pageId);

      const { attachments } = this.state;
      const lastIndex = this.state.attachments.length;
      //attachments.push(fileData[0]);
      attachments.push({
        progress: 10,
        file: fileData[index],
      });

      this.setState({ attachments });
      // send to service
      addCMSFile(data, {
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.warn(percentCompleted);

          const { attachments } = this.state;
          attachments[lastIndex].progress = percentCompleted;
          this.setState({ attachments });
        },
      }).then(res => {
        const { attachments } = this.state;
        attachments[lastIndex].progress = 0;
        attachments[lastIndex].id = res.messages.answerId;
        attachments[lastIndex].fileName = res.messages.documentName;

        this.setState({ attachments }, () => this.handleOnChange());
        console.warn('i completed', res);
      });
    });
  };

  deleteFile = index => {
    const { attachments } = this.state;
    const AnswerId = getAnswerId(attachments[index]);
    removeCMSFile({ AnswerId }).then(res => {
      if (res && res.success) {
        this.setState(prevState => ({
          attachments: prevState.attachments.filter(a => getAnswerId(a) !== AnswerId),
        }));
      }
    });
  };

  downloadFile = index => {
    const { attachments } = this.state;
    const AnswerId = getAnswerId(attachments[index]);
    downloadCMSFile({ AnswerId }).then(response => {
      if (response && response.success && response.attachmentData) {
        let data = response.attachmentData;
        let fileName = response.fileName;
        download(atob(data), fileName, mime.lookup(fileName));
      }
    });
  };

  onSelected = val => {
    this.setState(prevState => {
      const indexOfSelected = prevState.selectedAttachments.indexOf(val);
      return {
        selectedAttachments:
          indexOfSelected > -1
            ? prevState.selectedAttachments.filter((v, i) => i !== indexOfSelected)
            : [...prevState.selectedAttachments, val],
      };
    });
  };

  deleteSelected = val => {
    const { selectedAttachments, attachments } = this.state;
    const allPromises = [];
    selectedAttachments.forEach((val, index) => {
      const attachment = attachments[val];
      const AnswerId = getAnswerId(attachment);
      allPromises.push(
        removeCMSFile({ AnswerId }).then(res => {
          if (res && res.success) {
            this.setState(prevState => ({
              attachments: prevState.attachments.filter(a => getAnswerId(a) !== AnswerId),
            }));
            return Promise.resolve();
          }
          return Promise.reject();
        }),
      );
    });
    Promise.all(allPromises).then(() => this.setState({ selectedAttachments: [] }));
  };

  render() {
    const { attachments, selectedAttachments } = this.state;
    const { label, required, helpText } = this.props;
    console.warn('enabled', !!selectedAttachments.length);
    return (
      <div className="file-upload-wrapper full-width">
        <span className="upload-label">{label}</span>
        {required && <span className="required-sign"> * </span>}
        {helpText && <span>&nbsp;</span>}
        {helpText && <InfoTooltip toolTipText={helpText} />}
        <div className="upload-control-wrapper">
          <UploadPad dropHandler={this.handleOnDrop} acceptedFileTypes={getFileTypes(ATTACHMENT_TYPES).join()} closeHandler={null} />
        </div>
        <UploadView
          attachments={attachments}
          selectable={true}
          selectAction={'Delete'}
          menu={[
            { icon: 'Delete', text: 'Delete', handler: this.deleteFile },
            { icon: 'CloudDownload', text: 'Download', handler: this.downloadFile },
          ]}
          onSelected={this.onSelected}
          showBorder={true}
          deleteSelected={this.deleteSelected}
          deleteEnabled={!!selectedAttachments.length}
          selectedAttachments={selectedAttachments}
        />
      </div>
    );
  }
}

export default FileUploadControl;
